import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import API_DOMAIN from "../config/config";
import moment from "moment";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    padding: 12,
  },
  section: {
    flexDirection: "column",
    flexGrow: 1,
    border: 1,
    display: "flex",
  },
  text: {
    fontSize: 13,
    fontFamily: "Times-Roman",
    textAlign: "center",
    borderBottom: 1,
    width: "100%",
  },
  // Header styles
  headertext: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    borderBottom: 1,
    width: "100%",
    padding: 6,
  },
  head: {
    fontSize: 10,
    textAlign: "center",
  },
  date: {
    fontSize: 10,
    width: "50%",
    padding: 0,
    textAlign: "right",
  },
  title: {
    fontWeight: "bolder",
    fontSize: 15,
    textAlign: "center",
    width: "100%",
    marginBottom: 9,
  },
  companyaddress: {
    fontWeight: "bolder",
    fontSize: 10,
    textAlign: "center",
    width: "100%",
    marginBottom: 0,
  },
  companymobile: {
    fontWeight: "bolder",
    fontSize: 10,
    textAlign: "center",
    width: "100%",
    marginBottom: 7,
  },
  companygst: {
    fontWeight: "bold",
    fontSize: 11,
    textAlign: "center",
    width: "100%",
    marginBottom: 7,
  },
  name: {
    fontSize: 10,
    width: "50%",
    textAlign: "left",
  },
  // Table styles
  table: {
    display: "flex",
    padding: 6,
    justifyContent: "flex-end",
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  tableCell: {
    flex: 4,
    fontSize: 9,
    fontFamily: "Times-Roman",
  },
  // Product table styles
  producthead: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    borderBottom: 1,
  },
  producttitle: {
    fontSize: 9,
    fontFamily: "Times-Roman",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    borderBottom: 1,
    fontWeight: "bold",
  },
  productbody: {
    fontSize: 8,
    fontFamily: "Times-Roman",
    display: "flex",
    flexDirection: "row",
    borderBottom: 1,
  },
  bodydescription: {
    display: "flex",
    flexDirection: "column",
  },
  no: {
    width: "4%",
    borderRight: 1,
    padding: 5,
    textAlign: "center",
  },
  dataDate: {
    width: "8%",
    borderRight: 1,
    padding: 5,
    textAlign: "center",
  },
  dataReceipt: {
    width: "6%",
    borderRight: 1,
    padding: 5,
    textAlign: "center",
  },
  partyname: {
    width: "13%",
    borderRight: 1,
    padding: 5,
    textAlign: "left",
  },
  gstColumn: {
    width: "12%",
    borderRight: 1,
    padding: 5,
    textAlign: "left",
  },
  productColumn: {
    width: "16%",
    borderRight: 1,
    padding: 5,
    textAlign: "left",
    fontSize: 8,
  },
  qtyColumn: {
    width: "4%",
    borderRight: 1,
    padding: 5,
    textAlign: "center",
    fontSize: 8,
  },
  priceColumn: {
    width: "6%",
    borderRight: 1,
    padding: 5,
    textAlign: "right",
    fontSize: 8,
  },
  dataSubTotal: {
    width: "8%",
    borderRight: 1,
    padding: 5,
    textAlign: "right",
  },
  dataTax: {
    width: "7%",
    borderRight: 1,
    padding: 5,
    textAlign: "right",
  },
  dataDiscount: {
    width: "6%",
    borderRight: 1,
    padding: 5,
    textAlign: "right",
  },
  lastdataTax: {
    width: "10%",
    padding: 5,
    textAlign: "right",
  },
  dataend: {
    width: "10%",
    padding: 5,
    textAlign: "right",
  },
  // Footer styles
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 9,
    fontFamily: "Times-Roman",
    padding: 6,
    paddingBottom: 3,
  },
  // Total row styles
  totalRow: {
    fontSize: 10,
    fontFamily: "Times-Roman",
    display: "flex",
    flexDirection: "row",
    fontWeight: "bold",
  },
  totalLabel: {
    width: "69%", // Spans S No to Price
    borderRight: 1,
    padding: 5,
    textAlign: "right",
  },
  totalValueSub: {
    width: "8%",
    borderRight: 1,
    padding: 5,
    textAlign: "right",
  },
  totalValueTax: {
    width: "7%",
    borderRight: 1,
    padding: 5,
    textAlign: "right",
  },
  totalValueDisc: {
    width: "6%",
    borderRight: 1,
    padding: 5,
    textAlign: "right",
  },
  totalValueLast: {
    width: "10%",
    padding: 5,
    textAlign: "right",
  },
  noRecordRow: {
    fontSize: 12,
    fontFamily: "Times-Roman",
    display: "flex",
    flexDirection: "row",
    borderBottom: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  noRecordText: {
    flex: 1,
    textAlign: "center",
    padding: 10,
  },
});

const ITEMS_PER_PAGE = 18; // Number of items per page

const SaleRep = ({ data, fromdate, todate }) => {
  const subTotal = data.reduce(
    (acc, item) => acc + parseFloat(item.sub_total || 0),
    0
  );
  const subgrandtotal = data.reduce(
    (acc, item) => acc + parseFloat(item.total || 0),
    0
  );
  const discount = data.reduce(
    (acc, item) => acc + parseFloat(item.discount_amount || 0),
    0
  );
  const totalTaxAmount = data.reduce(
    (acc, item) => acc + parseFloat(item.gst_amount || 0),
    0
  );

  const chunkData = (data, size) => {
    const chunkedArray = [];
    for (let i = 0; i < data.length; i += size) {
      chunkedArray.push(data.slice(i, i + size));
    }
    return chunkedArray;
  };

  const companyDetails =
    data.length > 0
      ? data[0].company_details
      : { company_name: "", address: "", mobile_number: "", gst_no: "" };

  const sortedData =
    data.length > 0
      ? [...data].sort(
          (a, b) => moment(a.bill_date).toDate() - moment(b.bill_date).toDate()
        )
      : [];
  const pages = data.length > 0 ? chunkData(sortedData, ITEMS_PER_PAGE) : [[]];
  const totalPages = pages.length;
  const formattedFromDate = moment(fromdate).format("DD-MM-YYYY");
  const formattedtoDate = moment(todate).format("DD-MM-YYYY");

  return (
    <Document>
      {pages.map((pageData, pageIndex) => (
        <Page
          size="A4"
          orientation="landscape"
          style={styles.page}
          key={pageIndex}
        >
          <View style={styles.section}>
            <View style={styles.headertext}>
              <View style={styles.head}>
                <Text style={styles.title}>
                  {" "}
                  {companyDetails.company_name}{" "}
                </Text>
                <Text style={styles.companyaddress}>
                  {companyDetails.address}{" "}
                </Text>
                <Text style={styles.companymobile}>
                  {" "}
                  {companyDetails.mobile_number}{" "}
                </Text>
                <Text style={styles.companygst}>
                  GSTIN: {companyDetails.gst_no}{" "}
                </Text>
                {formattedFromDate !== "Invalid date" && (
                  <Text style={styles.companygst}>
                    Sales Details ({formattedFromDate} To {formattedtoDate})
                  </Text>
                )}
              </View>
            </View>
            <View style={styles.producthead}>
              <View style={styles.producttitle}>
                <Text style={styles.no}>S No</Text>
                <Text style={styles.dataDate}>Date</Text>
                <Text style={styles.dataReceipt}>Receipt No</Text>
                <Text style={styles.partyname}>Party Name</Text>
                <Text style={styles.gstColumn}>GST Number</Text>
                <Text style={styles.productColumn}>Product</Text>
                <Text style={styles.qtyColumn}>Qty</Text>
                <Text style={styles.priceColumn}>Price</Text>
                <Text style={styles.dataSubTotal}>Sub Total</Text>
                <Text style={styles.dataTax}>Tax Amount</Text>
                <Text style={styles.dataDiscount}>Discount</Text>
                <Text style={styles.lastdataTax}>Grand Total</Text>
              </View>
              <View style={styles.bodydescription}>
                {pageData.length > 0 ? (
                  pageData.map((product, index) => {
                    const gst = Array.isArray(product.product)
                      ? product.product.reduce(
                          (productAcc, product) =>
                            productAcc + parseFloat(product.tax_amt || 0),
                          0
                        )
                      : parseFloat(product.gst_amount || 0);
                    return (
                      <View style={styles.productbody} key={index}>
                        <Text style={styles.no}>
                          {pageIndex * ITEMS_PER_PAGE + index + 1}
                        </Text>
                        <Text style={styles.dataDate}>
                          {product.bill_date || "N/A"}
                        </Text>
                        <Text style={styles.dataReceipt}>
                          {product.bill_no || "N/A"}
                        </Text>
                        <Text style={styles.partyname}>
                          {product.party_name || "N/A"}
                        </Text>
                        <Text style={styles.gstColumn}>
                          {product.party_details?.gst_no || "N/A"}
                        </Text>
                        <Text style={styles.productColumn}>
                          {Array.isArray(product.product)
                            ? product.product
                                .map((p) => p.product_name)
                                .join(", ")
                            : "N/A"}
                        </Text>
                        <Text style={styles.qtyColumn}>
                          {Array.isArray(product.product)
                            ? product.product.map((p) => p.qty).join(", ")
                            : "0"}
                        </Text>
                        <Text style={styles.priceColumn}>
                          {Array.isArray(product.product)
                            ? product.product.map((p) => p.price_unit).join(", ")
                            : "0"}
                        </Text>
                        <Text style={styles.dataSubTotal}>
                          {(parseFloat(product.sub_total) || 0).toFixed(2)}
                        </Text>
                        <Text style={styles.dataTax}>
                          {(parseFloat(product.gst_amount) || 0).toFixed(2)}
                        </Text>
                        <Text style={styles.dataDiscount}>
                          {(parseFloat(product.discount_amount) || 0).toFixed(
                            2
                          )}
                        </Text>
                        <Text style={styles.lastdataTax}>
                          {(parseFloat(product.total) || 0).toFixed(2)}
                        </Text>
                      </View>
                    );
                  })
                ) : (
                  <View style={styles.noRecordRow}>
                    <Text style={styles.noRecordText}>No Record Found</Text>
                  </View>
                )}

                {pageIndex === totalPages - 1 && data.length > 0 && (
                  <View style={styles.totalRow}>
                    <Text style={styles.totalLabel}>Total</Text>
                    <Text style={styles.totalValueSub}>{subTotal.toFixed(2)}</Text>
                    <Text style={styles.totalValueTax}>
                      {totalTaxAmount.toFixed(2)}
                    </Text>
                    <Text style={styles.totalValueDisc}>{discount.toFixed(2)}</Text>
                    <Text style={styles.totalValueLast}>
                      {subgrandtotal.toFixed(2)}
                    </Text>
                  </View>
                )}
              </View>
            </View>
            <Text style={styles.footer}>
              Page {pageIndex + 1} of {totalPages}
            </Text>
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default SaleRep;
